import axios, { AxiosHeaders, AxiosInstance, AxiosRequestConfig } from 'axios';
import { getCookie } from 'utils/Cookies';

const requestConfig: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

class HttpApiService {
  axiosInstance: AxiosInstance;
  constructor() {
    this.axiosInstance = axios.create(requestConfig);

    this.axiosInstance.interceptors.request.use(config => {
      config.headers = config.headers ?? {};
      config.headers = config.headers as AxiosHeaders;
      config.headers.set('Authorization', `Bearer ${getCookie('apiToken')}`);
      return config;
    });

    this.axiosInstance.interceptors.response.use(
      res => {
        // to do handle response
        return res;
      },
      error => {
        // to do handle error
        return Promise.reject(error);
      }
    );
  }
}

const api = new HttpApiService().axiosInstance;

export default api;
